<section class="select-lab">
  <header class="select-lab__header">
    <h1>Laboratório do app-select</h1>
    <p>Página de teste para acompanhar eventos, mudanças de valor e possíveis loops.</p>
    <div class="select-lab__actions">
      <button appButton buttonType="outline" label="Limpar logs" (click)="clearLogs()"></button>
      <button
        appButton
        buttonType="primary"
        label="Resetar estados"
        (click)="resetAllStates()"></button>
    </div>
  </header>

  <section class="select-lab__group select-lab__group--ngmodel">
    <h2 class="select-lab__group-title">Cenários com ngModel</h2>
    <div class="select-lab__grid">
      <article class="select-lab__card">
        <h3>1) Sem opções (inicial vazio)</h3>
        <app-select
          label="Select vazio"
          placeholder="Nenhuma opção disponível"
          [options]="[]"
          [emptyMessage]="'Nada para mostrar'"
          [showClear]="true"
          [(ngModel)]="ngModelSingleValue"
          (ngModelChange)="onNgModelChange('empty-initial', $event)"
          (optionSelectedChange)="onOutput('empty-initial.optionSelectedChange', $event)"
          (sendSelectedOption)="onOutput('empty-initial.sendSelectedOption', $event)"
          (dropdownHide)="onOutput('empty-initial.dropdownHide')">
        </app-select>
        <pre>{{ ngModelSingleValue | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('empty-initial') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>2) ngModel simples</h3>
        <app-select
          label="Prioridade (ngModel)"
          placeholder="Selecione"
          [options]="baseOptions"
          [showClear]="true"
          [(ngModel)]="ngModelSingleValue"
          (ngModelChange)="onNgModelChange('ngModel-single', $event)"
          (optionSelectedChange)="onOutput('ngModel-single.optionSelectedChange', $event)"
          (sendSelectedOption)="onOutput('ngModel-single.sendSelectedOption', $event)"
          (sendfilterChange)="onOutput('ngModel-single.sendfilterChange', $event)"
          (dropdownHide)="onOutput('ngModel-single.dropdownHide')">
        </app-select>
        <pre>{{ ngModelSingleValue | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('ngModel-single') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>3) ngModel múltiplo</h3>
        <app-select
          label="Prioridades (ngModel múltiplo)"
          placeholder="Selecione várias"
          [options]="baseOptions"
          [multiple]="true"
          [(ngModel)]="ngModelMultiValues"
          (ngModelChange)="onNgModelChange('ngModel-multi', $event)"
          (sendSelectedOptionMultiple)="
            onOutput('ngModel-multi.sendSelectedOptionMultiple', $event)
          "
          (sendfilterChange)="onOutput('ngModel-multi.sendfilterChange', $event)"
          (dropdownHide)="onOutput('ngModel-multi.dropdownHide')">
        </app-select>
        <pre>{{ ngModelMultiValues | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('ngModel-multi') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>4) ngModel com valor inicial e opções com timeout</h3>
        <app-select
          label="Carregamento tardio (ngModel)"
          placeholder="Aguardando opções..."
          [options]="delayedOptions"
          [loading]="delayedOptionsLoading"
          [(ngModel)]="ngModelDelayedValue"
          (ngModelChange)="onNgModelChange('ngModel-delayed', $event)"
          (optionSelectedChange)="onOutput('ngModel-delayed.optionSelectedChange', $event)"
          (sendSelectedOption)="onOutput('ngModel-delayed.sendSelectedOption', $event)"
          (dropdownHide)="onOutput('ngModel-delayed.dropdownHide')">
        </app-select>
        <pre>{{ { loading: delayedOptionsLoading, value: ngModelDelayedValue } | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('ngModel-delayed') }}</pre>
      </article>
    </div>
  </section>

  <section class="select-lab__group select-lab__group--form">
    <h2 class="select-lab__group-title">Cenários com FormGroup</h2>
    <div class="select-lab__grid">
      <article class="select-lab__card">
        <h3>5) FormGroup simples</h3>
        <form [formGroup]="form">
          <app-select
            label="Prioridade (FormGroup)"
            placeholder="Selecione"
            [options]="baseOptions"
            [formGroup]="form"
            controlName="single"
            (optionSelectedChange)="onOutput('form-single.optionSelectedChange', $event)"
            (sendSelectedOption)="onOutput('form-single.sendSelectedOption', $event)"
            (sendfilterChange)="onOutput('form-single.sendfilterChange', $event)"
            (dropdownHide)="onOutput('form-single.dropdownHide')">
          </app-select>
        </form>
        <pre>{{ form.get('single')?.value | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('form-single') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>6) FormGroup múltiplo</h3>
        <form [formGroup]="form">
          <app-select
            label="Prioridades (FormGroup múltiplo)"
            placeholder="Selecione várias"
            [options]="baseOptions"
            [multiple]="true"
            [formGroup]="form"
            controlName="multi"
            (sendSelectedOptionMultiple)="onOutput('form-multi.sendSelectedOptionMultiple', $event)"
            (sendfilterChange)="onOutput('form-multi.sendfilterChange', $event)"
            (dropdownHide)="onOutput('form-multi.dropdownHide')">
          </app-select>
        </form>
        <pre>{{ form.get('multi')?.value | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('form-multi') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>7) FormGroup com valor inicial e opções com timeout</h3>
        <form [formGroup]="form">
          <app-select
            label="Carregamento tardio (FormGroup)"
            placeholder="Aguardando opções..."
            [options]="delayedOptions"
            [loading]="delayedOptionsLoading"
            [formGroup]="form"
            controlName="delayedSingle"
            (optionSelectedChange)="onOutput('form-delayed.optionSelectedChange', $event)"
            (sendSelectedOption)="onOutput('form-delayed.sendSelectedOption', $event)"
            (dropdownHide)="onOutput('form-delayed.dropdownHide')">
          </app-select>
        </form>
        <pre>{{
          { loading: delayedOptionsLoading, value: form.get('delayedSingle')?.value } | json
        }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('form-delayed') }}</pre>
      </article>

      <article class="select-lab__card">
        <h3>8) FormGroup com appAutoFormGroup (sem [formGroup] no app-select)</h3>
        <form [formGroup]="form" appAutoFormGroup>
          <app-select
            label="Prioridade (auto form group)"
            placeholder="Selecione"
            [options]="baseOptions"
            controlName="autoSingle"
            (optionSelectedChange)="onOutput('form-auto.optionSelectedChange', $event)"
            (sendSelectedOption)="onOutput('form-auto.sendSelectedOption', $event)"
            (dropdownHide)="onOutput('form-auto.dropdownHide')">
          </app-select>
        </form>
        <pre>{{ form.get('autoSingle')?.value | json }}</pre>
        <pre class="select-lab__card-log">{{ getScenarioLogText('form-auto') }}</pre>
      </article>
    </div>
  </section>

  <section class="select-lab__logs">
    <h2>Log de eventos</h2>
    <pre *ngIf="logs.length === 0">Sem eventos ainda.</pre>
    <pre *ngIf="logs.length > 0">{{ logs.join('\n') }}</pre>
  </section>
</section>
